export const initCategoryAndTenor = {
  value: 0,
  label: "Semua",
};

export const initPaymentAndTenorType = {
  value: "semua",
  label: "Semua",
};

export const paymentTypeList = [
  {
    value: "semua",
    label: "Semua",
  },
  {
    value: "balloon_payment",
    label: "Balloon Payment",
  },
  {
    value: "installment",
    label: "Installment",
  },
];

export const paymentMethodList = [
  {
    value: "semua",
    label: "Semua",
  },
  {
    value: "cash",
    label: "Tunai",
  },
  {
    value: "transfer",
    label: "Non-Tunai",
  },
  {
    value: "midtrans",
    label: "Virtual Account",
  },
];

export const tenorTypeList = [
  {
    value: "semua",
    label: "Semua",
  },
  {
    value: "reguler",
    label: "Reguler",
  },
  {
    value: "non_reguler",
    label: "Non Reguler",
  },
];
